import _toConsumableArray from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";
import "core-js/modules/es.array.map.js";
import { getLoadingDecorator, getMessageDecorator } from 'decor-core';
import loading from 'components/Loading';
import { handleResponseDataToList } from 'decor-core/lib/handle';
import { ProdStaticUrl, superdiamondEnvConfig } from '@/utils/request';
var env = process.env.VUE_APP_ENV;
var loadingConfig = {
  duration: 0,
  // message: '加载中...',
  forbidClick: true
};
export var setLoadingDecorator = getLoadingDecorator(function () {
  return loading.show(loadingConfig);
}, loading.hide);
export var handleGetTargetData = handleResponseDataToList('data');
export var setMessageDecorator = getMessageDecorator({
  success: _Toast.success,
  error: _Toast
});
export var handleFilterList = function handleFilterList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (x) {
    return _toConsumableArray(x.data);
  });
};
export var baseURLConfig = {
  baseURL: ProdStaticUrl
};
export var superdiamondEnv = superdiamondEnvConfig[env];